import { Alert } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { INTRO_CONTENT_AMENDS_KEY, INTRO_NOTE_AMENDS_KEY } from "../../amends/lib/constants/amends-keys"

export function IntroductionAmendsHint() {
    const { amendsContext, projectGroup } = useBoundContext()
    if (!amendsContext || projectGroup?.readOnly) return null

    const missingIntroduction = isMissingAmends(INTRO_CONTENT_AMENDS_KEY)
    const missingNotes = isMissingAmends(INTRO_NOTE_AMENDS_KEY)
    if (!missingIntroduction && !missingNotes) return null

    return (
        <Alert severity="info" variant="outlined" sx={{ py: 0.5, mb: 1 }} data-cy="introduction-amends-hint">
            This introduction does not have author notes attached. Adding notes is recommended so they are included when
            this group is applied across schedules.
        </Alert>
    )

    function isMissingAmends(amendsKey) {
        const state = amendsContext.getAmendsState(amendsKey)
        return Boolean(state.canOpen && !state.hasSavedAmends && !state.isOpen)
    }
}
